<template>
  <div class="card-wrapper reasons-page-wrap">
    <ReasonsHeader />
    <div class="reasons-page container">
      <div class="row">
        <div class="page-introduction">
          <h4 class="page-introduction_title">
            The creation of special economic zones,
          </h4>
          <span class="page-introduction_subtitle"
            >Including the Nkok Special Economic Zone, the most advanced
            multi-sector park in Central Africa.</span
          >
          <p class="page-introduction_description">
            Since 2011, Gabon has created 8 special economic zones in the
            priority sectors of its economy (wood processing, agriculture,
            metallurgy, etc.) to stimulate foreign direct investment
          </p>
          <a
            href="https://a.storyblok.com/f/43998/x/92e81d5d28/reasons-to-invest-in-gabon-all.pdf"
            target="_blank"
            class="page-introduction_link"
            >Download full PDF</a
          >
        </div>
        <div class="page-content">
          <h3>
            An economic zone policy that accelerates the country’s
            industrialization
          </h3>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">1</span>
              <span class="section-title"
                >Creation in 2011 of the Nkok SEZ, a symbol of the country’s
                diversification and economic transformation
              </span>
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    Located 27 km from Libreville, the SEZ of Nkok has an area
                    of 1126 ha. It is connected to the port by a railway, and
                    has its own water and electricity infrastructure
                  </li>
                  <li>
                    This industrial competitiveness cluster benefits from
                    simplified administrative procedures and advantageous
                    tax-customs incentives
                  </li>
                  <li>
                    The FDI Intelligence of Financial Time awarded the ZES of
                    Nkok in 2020 the prize of "Global Free Zone of the Year" in
                    the category Wood products.
                  </li>
                  <li>
                    Nkok SEZ is the first industrial area in the world to be
                    certified as “low carbon” through ISO 14064-1 certification
                  </li>
                </ul>
                <p>
                  <a href="https://www.gsez.com/" target="_blank"
                    >https://www.gsez.com/</a
                  >
                </p>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-6.png" />
              </div>
            </div>
          </section>

          <section class="section-even">
            <div class="section-header">
              <span class="section-num">2</span>
              <span class="section-title"
                >Ikolo Economic Zone launched in 2021 to continue wood
                processing efforts
              </span>
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    Strong to the success of the ZES of Nkok, Gabon has acquired
                    a new industrial pole specialized in 2nd and 3rd wood
                    processing.
                  </li>
                  <li>
                    With an area of 840 ha of which 522 ha protected and 318 ha
                    exploited, the area is located in west-central Gabon.
                  </li>
                  <li>
                    Like the Nkok SEZ, the new zone offers the same advantages
                    in terms of supporting investors and tax-customs incentives.
                  </li>
                </ul>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-7.png" />
              </div>
            </div>
          </section>

          <section class="section-odd">
            <div class="section-header">
              <span class="section-num">3</span>
              <span class="section-title"
                >Creation of High Productivity Agricultural Areas (ZAP) to
                increase the share of agriculture in the Gross Domestic Product
                (GDP).</span
              >
            </div>

            <div class="section-card">
              <div class="card-content">
                <ul>
                  <li>
                    Gabon has created 5 PAZ in three provinces representing a
                    total of 55,000 hectares of available and secure land.
                  </li>
                  <li>
                    The zones offer investors a lot of advantages: cadastre
                    lands, proximity to road, rail and port communications
                    routes, access to major regional consumer markets (CEMAC 1
                    and ZLECAf 2), reduction of tax and customs taxes, etc.
                  </li>
                </ul>
                <p>
                  <b
                    >1. The Central African Economic and Monetary Community
                    (CEMAC) <br />
                    2. African Continental Free Trade Area</b
                  >
                </p>
              </div>
              <div class="card-image">
                <img src="/media/platforms/gabon/reasons-8.png" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReasonsHeader from "./reasons-header.vue";

export default {
  name: "reasons-1",
  components: { ReasonsHeader },
};
</script>

<style scoped lang="scss" src="./reasons.scss"></style>
